import { render, staticRenderFns } from "./vTree.vue?vue&type=template&id=3c1c684a&scoped=true&"
import script from "./vTree.vue?vue&type=script&lang=js&"
export * from "./vTree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1c684a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/nisems/front/nisbos-front-admin/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c1c684a')) {
      api.createRecord('3c1c684a', component.options)
    } else {
      api.reload('3c1c684a', component.options)
    }
    module.hot.accept("./vTree.vue?vue&type=template&id=3c1c684a&scoped=true&", function () {
      api.rerender('3c1c684a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ls-form/components/saas/vTree.vue"
export default component.exports